<ada-toggle-switch
	[isToggled]="isToggled"
	[label]="'Show Deleted Objects'"
	[margin]="deletedObjectMargin"
	(isToggledChange)="toggleStaticFilter($event)"
/>
